import { compact } from 'lodash-es';
import { extractPureTextFromRichText } from 'seagull';
import { approvalMethodNoticePeriodModel, relationshipModel } from '~/models';
import { requestAccountantAccessModel } from '~/models/request-accountant-access';
export const additionalTermsTextsPath = 'clientFlow.additionalTerms';
const hasAgreementNotes = (extraClause)=>!!extraClause && extractPureTextFromRichText(extraClause).trim().length > 0;
export const getAdditionalTermsData = (relationship, texts)=>{
    var _relationship_extraClause;
    return compact([
        {
            key: 'effectiveDate',
            title: texts.effectiveDate(),
            description: relationshipModel.formatEffectiveDate(relationship)
        },
        {
            key: 'paymentTerms',
            title: texts.paymentTerms(),
            description: relationshipModel.paymentTermsText(relationship)
        },
        {
            key: 'amendments',
            title: texts.amendments(),
            description: approvalMethodNoticePeriodModel.amendmentsDescription(relationship.amendmentsApprovalMethod)
        },
        approvalMethodNoticePeriodModel.isAutoApproval(relationship.invoicesApprovalMethod) && {
            key: 'outOfScopeCharges',
            title: texts.outOfScopeCharges(),
            description: approvalMethodNoticePeriodModel.invoicesDescription(relationship.invoicesApprovalMethod)
        },
        requestAccountantAccessModel.wasRequested(relationship.requestAccountantAccess) && {
            key: 'accountantAccess',
            title: texts.accountantAccess(),
            description: texts.accountantAccessDescription({
                vendorName: relationship.vendor.name
            })
        },
        hasAgreementNotes(relationship.extraClause) && {
            key: 'agreementNotes',
            title: texts.agreementNotes(),
            description: (_relationship_extraClause = relationship.extraClause) !== null && _relationship_extraClause !== void 0 ? _relationship_extraClause : ''
        }
    ]);
};
